import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLocalStoreDefaultPrice, getUserData, setLocalStoreDefaultPrice } from "../../../utils/localStorage";
import { storeCustomerGetInfo } from "../../../services/CustomerInfo/CustomerInfo";
import {
  getCustomerSingleB2BOrderInfo,
  getOrderDocs,
} from "../../../services/OrdersAPI/Orders";
import { getStoreDefaultPrice } from "../../../services/StoreDefaultPrice/getStoreDefaultPrice";
import OrderUnprocessedQrCode from "../OrderUnprocessedQrCode";
import SuccessModal from "../../SuccessModal";
import StoreMenu from "../../StoreMenu";
import { useRef } from "react";
import OrderInfoEditByProfile from "../OrderInfoEditByProfile";
import ButtonLink from "../../../ButtonLink";
import B2BOrderInfoCard from "./B2BOrderInfoCard";
import B2BGarmentInfoCard from "./B2BGarmentInfoCard";
import B2BOrderCancelModal from "./B2BOrderCancelModal";
import B2BOrderInfoEdit from "./B2BOrderInfoEdit";
import { B2BOrderInfoEditAPI } from "../../../services/OrderEdit/orderInfoEdit";

const { innerWidth: width, innerHeight: height } = window;

const CardDataBeforeProcessOrder = [

  {
    id: 1,
    name: "Mark Ready",
    fillColor: "#E7F4FF",
    borderColor: "#3EB3E1",
    img: "Laundy_App_Icons_Gifs/Other_Icons/Process_Order.png",
  },
  {
    id: 2,
    name: "Cancel Challan",
    fillColor: "#FFEEEE",
    borderColor: "#FF6767",
    img: "Laundy_App_Icons_Gifs/Other_Icons/Cancel_Order.png",
  },
];

const CardDataAfterProcessOrder = [
  {
    id: 1,
    name: "Deliver Challan",
    fillColor: "#E7F4FF", // You can set the desired colors
    borderColor: "#3EB3E1", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Other_Icons/Deliver_Order.png", // Provide the correct image path
  },
]

const CardDataAfterCancelOrder = [
  {
    id: 1,
    name: "Canceled Challan",
    // fillColor: '#E7F4FF', // You can set the desired colors
    borderColor: "red", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Cancel_Order.gif", // Provide the correct image path
  },
];

const B2BOrdersGarmentInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeCustomerId, bookingOrderId, navigateThrough, callThrough } =
    location.state || {}; // Fallback to prevent undefined errors

  const {
    brandProfileData,
    storeData,
    userProfileData,
    userProfileRole,
    garmentCategoryServiceIconsResData,
  } = getUserData();

  const storeId = storeData.id;
  const userRole = userProfileRole;
  const userProfileId = userProfileData.id;

  let brandId = brandProfileData.id;
  const storeUserId = userProfileData.id;
  const processTime = storeData.processTime;
  let orderEditByStore = storeData.orderEditByStore;
  let orderEditByRider = storeData.orderEditByRider;
  const enabledChargeDiscountByService =
    storeData.enabledChargeDiscountByService;
  let enabledCreatePaymentLink = storeData.enabledCreatePaymentLink;
  let offerPriceEnabled = storeData.offerPriceEnabled;

  let enableCancelOrder = storeData.enableCancelOrder;
  const garmentMaxProcessCount = brandProfileData.garmentMaxProcessCount;

  const offerDiscountByStore = storeData.offerDiscountByStore;
  const offerDiscountByRider = storeData.offerDiscountByRider;

  const [cancelOrderModal, setCancelOrderModal] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalStatusText, setModalStatusText] = useState("");

  const [processOrderActive, setProcessOrderActive] = useState(null);
  const [showCancelOrder, setShowCancelOrder] = useState(false);
  const [customerOrdersData, setCustomerOrdersData] = useState({});

  const [storeCustomerData, setStoreCustomerData] = useState({});
  const [orderInfoEditVisible, setOrderInfoEditVisible] = useState(false);
  const [orderUnprocessedQrCode, setOrderUnprocessedQrCode] = useState(false);
  const [storeDefaultPrice, setStoreDefaultPrice] = useState([]);
  const [visible, setVisible] = useState(false);
  const [orderInfoEditByProfileVisible, setOrderInfoEditByProfileVisible] =
    useState(false);

  const op = useRef(null);

  const [selectedInfoType, setSelectedInfoType] = useState({
    name: "Garment Info",
    code: "Garment Info",
  });


  const handleBackButton = () => {
    if (userRole === "BY_STORE") {
      if (navigateThrough === "GoBack") {
        navigate(-1);
      } else {
        navigate("/CustomerInfo", {
          state: {
            storeCustomerId: storeCustomerId,
          },
        });
      }
    } else {
      navigate("/");
    }
  };

  const fetchStoreCustomerGetInfo = () => {
    storeCustomerGetInfo(storeCustomerId, storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreCustomerData(Res);
        }
      })
      .catch((err) => {
        console.error("storeCustomerGetInfo Error:", err);
      });
  };

  const fetchCustomerSingleOrder = () => {
    getCustomerSingleB2BOrderInfo(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOrdersData(Res);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });

  };

  

  // store in local storage
  const fetchDefaultPrice = async () => {
    try {
      const response = await getStoreDefaultPrice(storeId);
      if (!response.data.error) {
        const Res = response.data;
        setStoreDefaultPrice(Res);
        setLocalStoreDefaultPrice(Res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalStoreDefaultPrice = async () => {
    const { storeDefaultPrice } = getLocalStoreDefaultPrice();
    if (storeDefaultPrice && Object.keys(storeDefaultPrice).length > 0) {
      setStoreDefaultPrice(storeDefaultPrice);
    } else {
      await fetchDefaultPrice();
    }
  };

  const [readyToDeliveryUnprocessedData, setReadyToDeliveryUnprocessedData] =
    useState([]);



  const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);

  const receiveResponse = ({ message, status, modalFun }) => {
    setModalStatusText(status ? "success" : "failed");
    setModalText(message);
    setCollectPaymentResponse(modalFun);
    fetchCustomerSingleOrder();
  };

  useEffect(() => {
    if (collectPaymentResponse === false) {
      setModalVisible(true);
      setCollectPaymentResponse(null);
    }
  }, [collectPaymentResponse]);

  useEffect(() => {
    fetchCustomerSingleOrder();
    fetchStoreCustomerGetInfo();
    fetchLocalStoreDefaultPrice();
  }, []);

  useEffect(() => {
    let intervalId;

    if (customerOrdersData?.documentScheduled) {
      intervalId = setInterval(() => {
        fetchCustomerSingleOrder();
        if (!customerOrdersData?.documentScheduled) {
          clearInterval(intervalId);
        }
      }, 5000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [customerOrdersData?.documentScheduled]);

  const renderCardBeforeProcessOrder = () => {
    return CardDataBeforeProcessOrder?.map((item, index) => {
      const showLock = item.id === 2 && !enableCancelOrder;

      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            if (!showLock) {
              onSelectCategoryBeforeProcessOrder(item);
            }
          }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >
              {showLock ? (
                <img
                  src={"Icons/lock.png"}
                  style={{
                    width: height < 600 ? 45 : 50,
                    height: height < 600 ? 45 : 50,
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <img
                  src={item.img}
                  style={{
                    width: height < 600 ? 25 : 30,
                    height: height < 600 ? 25 : 30,
                    alignSelf: "center",
                  }}
                />
              )}
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      );
    });
  };

  const onSelectCategoryBeforeProcessOrder = (item) => {
    if (item.id === 1) {


      const currentDateTimeBookingDate = new Date(customerOrdersData?.createdDate).toISOString();
      const currentDateTimeDeliveryDate = new Date(
        customerOrdersData?.deliveryOn
      ).toISOString();
      const currentDateTimeDeliveredOnDate = new Date(
        customerOrdersData?.deliveredOn
      ).toISOString();

      const data = {
        id: customerOrdersData?.id,
        status: "PROCESSED",
        storeUserId: storeUserId,
        createdDate: currentDateTimeBookingDate,
        deliveryOn: currentDateTimeDeliveryDate,
        urgentDelivery: false,
        deliveryRequest: false,
        regenerateInvoice: false,
        regenerateQRCode: false,
        remarks: "",
        // deliveredOn: currentDateTimeDeliveredOnDate,
        deliveredOn: new Date(),
        customerName: [
          storeCustomerData?.brandCustomer?.firstName,
          storeCustomerData?.brandCustomer?.lastName,
        ]
          .filter(
            (name) =>
              name &&
              name !== "null" &&
              name !== "undefined"
          )
          .join(" "),
        customerMobile: storeCustomerData?.brandCustomer?.mobile,
        customerAddress: storeCustomerData?.address?.address,
      };

      // Call the service function for creating pickup request
      B2BOrderInfoEditAPI(storeCustomerId, storeId, customerOrdersData?.id, data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res) {
              const message = Res.message;
              const status = Res.status;

              setModalVisible(true);
              setModalStatusText(status ? "success" : "failed");
              setModalText(message);

              fetchCustomerSingleOrder();
              fetchStoreCustomerGetInfo();
              fetchLocalStoreDefaultPrice();
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });


    } else if (item.id === 2) {
      setCancelOrderModal(true);
    }
  }

  const onSelectCategoryAfterProcessOrder = (item) => {
    if (item.id === 1) {
      const currentDateTimeBookingDate = new Date(customerOrdersData?.createdDate).toISOString();
      const currentDateTimeDeliveryDate = new Date(
        customerOrdersData?.deliveryOn
      ).toISOString();
      const currentDateTimeDeliveredOnDate = new Date(
        customerOrdersData?.deliveredOn
      ).toISOString();

      const data = {
        id: customerOrdersData?.id,
        status: "DELIVERED",
        storeUserId: storeUserId,
        createdDate: currentDateTimeBookingDate,
        deliveryOn: currentDateTimeDeliveryDate,
        urgentDelivery: false,
        deliveryRequest: false,
        regenerateInvoice: false,
        regenerateQRCode: false,
        remarks: "",
        // deliveredOn: currentDateTimeDeliveredOnDate,
        deliveredOn: new Date(),
        customerName: [
          storeCustomerData?.brandCustomer?.firstName,
          storeCustomerData?.brandCustomer?.lastName,
        ]
          .filter(
            (name) =>
              name &&
              name !== "null" &&
              name !== "undefined"
          )
          .join(" "),
        customerMobile: storeCustomerData?.brandCustomer?.mobile,
        customerAddress: storeCustomerData?.address?.address,
      };

      // Call the service function for creating pickup request
      B2BOrderInfoEditAPI(storeCustomerId, storeId, customerOrdersData?.id, data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res) {
              const message = Res.message;
              const status = Res.status;

              setModalVisible(true);
              setModalStatusText(status ? "success" : "failed");
              setModalText(message);

              fetchCustomerSingleOrder();
              fetchStoreCustomerGetInfo();
              fetchLocalStoreDefaultPrice();

            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });


    }
  }

  const renderCardAfterProcessOrder = () => {
    return CardDataAfterProcessOrder?.map((item, index) => {

      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            onSelectCategoryAfterProcessOrder(item);
          }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >

              <img
                src={item.img}
                style={{
                  width: height < 600 ? 25 : 30,
                  height: height < 600 ? 25 : 30,
                  alignSelf: "center",
                }}
              />
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      );
    });
  };

  const renderCardAfterCancelOrder = () => {
    return CardDataAfterCancelOrder?.map((item, index) => (
      <div>
        <div className="flex justify-content-center align-items-center">
          <div
            className="flex justify-content-center align-items-center border-1"
            style={{
              height: height < 600 ? 51 : 61,
              width: height < 600 ? 51 : 61,
              backgroundColor: item.fillColor,
              borderRadius: 50,
              borderColor: item.borderColor,
            }}
          >
            <img
              src={item.img}
              style={{
                width: height < 600 ? 25 : 30,
                height: height < 600 ? 25 : 30,
                alignSelf: "center",
              }}
            />
          </div>
        </div>

        <div className="py-2">
          <p
            className="text-xl font-normal capitalize"
            style={
              index === 0 && processOrderActive === item.id
                ? { color: "#008EFF" }
                : { color: "#75879B" }
            }
          >
            {item.name}
          </p>
        </div>
      </div>
    ));
  };


  const CustomerInformation = {
    firstName: storeCustomerData?.brandCustomer?.firstName
      ? storeCustomerData?.brandCustomer?.firstName
      : "",
    lastName: storeCustomerData?.brandCustomer?.lastName
      ? storeCustomerData?.brandCustomer?.lastName
      : "",
    mobile: storeCustomerData?.brandCustomer?.mobile
      ? storeCustomerData?.brandCustomer?.mobile
      : "N/A",
  };

  const selectedUnprocessedQrCodeItems = readyToDeliveryUnprocessedData.map(
    (item) => ({
      id: item.id,
      qrcode: item.qrcode,
      checked: true,
    })
  );

  const orderInfoDetailsBalanceAmount = {
    balanceAmount: customerOrdersData?.balanceAmount
      ? customerOrdersData?.balanceAmount
      : 0,
  };

  const orderItemData = customerOrdersData?.orderItem;



  const orderPackageData = customerOrdersData?.orderPackage;

  const receiveDataFromCancelModal = ({ dataRes }) => {
    // setSchedularDate(newSchedular);
    if (dataRes) {
      fetchCustomerSingleOrder();
    }
  };







  const receiveDataFromGarmentInfoCard = ({ info }) => {
    if (info) {
      fetchCustomerSingleOrder();
      fetchStoreCustomerGetInfo();
      fetchLocalStoreDefaultPrice();
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#fff",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left cursor-pointer"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#000" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5 flex justify-content-start align-items-center">
              <p className=" text-2xl font-bold capitalize">Challan Info</p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => navigate("/")}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                marginRight: 2,
              }}
            >
              <img
                src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/home-button.png"}
                style={{
                  width: 40,
                }}
              />
            </div>
          </div>

          {(customerOrdersData.editBy > 0 ||
            customerOrdersData.editBy !== null) && (
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                onClick={() => setOrderInfoEditByProfileVisible(true)}
              >
                <div
                  className="px-3 py-1 cursor-pointer"
                  style={{
                    backgroundColor: "green",
                    borderRadius: 5,
                    marginRight: 20,
                  }}
                >
                  <p className=" text-lg text-white font-medium capitalize">
                    Last Edited By
                  </p>
                </div>
              </div>
            )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#000" }}
            ></i>
          </div>
        </div>
      </div>

      <div
        className="border-none surface-0 flex-1  mx-4 py-1 mb-3"
        style={{
          borderRadius: 5,
          backgroundImage:
            "radial-gradient(circle at left top, #1752AA, #2B70D7)",
        }}
      >
        <div className="px-4">
          <div
            className="flex cursor-pointer"
            onClick={() => {
              navigate("/CustomerInfo", {
                state: {
                  storeCustomerId: storeCustomerId,
                },
              });
            }}
          >
            <div className="flex-1 flex justify-content-start align-items-center">
              <p className="text-white text-lg font-normal capitalize">
                Customer Name :
              </p>
              <p className="text-white text-xl font-semibold capitalize ml-2">
                {CustomerInformation?.firstName} {CustomerInformation?.lastName}
              </p>
            </div>
            <div className="flex-1 flex justify-content-start align-items-center">
              <p className="text-white text-lg font-normal capitalize ">
                Mobile No. :
              </p>
              <p className="text-white text-xl font-semibold capitalize ml-2">
                {CustomerInformation?.mobile}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-1 justify-content-around align-item-center">
        {
          customerOrdersData.status === "BOOKED" && !showCancelOrder && (
            renderCardBeforeProcessOrder()
          )
        }
        {customerOrdersData.status === "PROCESSED" && renderCardAfterProcessOrder()}
        {customerOrdersData.status === "CANCEL" && renderCardAfterCancelOrder()}
      </div>

      <div className="flex flex-1">
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5", position: "relative" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">Challan Info</p>
              </div>
            </div>

            <div>
              {!["ORDERED", "CANCEL"].includes(
                customerOrdersData.status
              ) && (
                  <div
                    style={{
                      position: "absolute",
                      right: 30,
                      top: 9,
                    }}
                  >
                    {(userRole === "BY_STORE" && orderEditByStore) ||
                      (userRole === "BY_RIDER" && orderEditByRider) ? (
                      <div>
                        <div onClick={() => setOrderInfoEditVisible(true)}>
                          <i
                            className="pi pi-pencil"
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "#2B70D7",
                            }}
                          ></i>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div>
                          <i
                            className="pi pi-pencil"
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "#2B70D7",
                            }}
                          ></i>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                          }}
                        >
                          <img
                            src={"Icons/lock.png"}
                            style={{
                              width: 18,
                              height: 18,
                              backgroundColor: "transparent",
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </div>
          </div>
          <B2BOrderInfoCard
            customerOrdersData={customerOrdersData}
            storeCustomerId={storeCustomerId}
            bookingOrderId={bookingOrderId}
            userRole={userRole}
            storeInfo={storeData}
            brandInfo={brandProfileData}
          />


        </div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0 mb-3"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between ml-4">
              <div className="py-1 flex gap-2">
                <p className=" text-2xl  font-bold ">{selectedInfoType.code}</p>
              </div>



              <div className="flex justify-content-center align-items-center">
                {customerOrdersData.status === "BOOKED" && (
                  <div className="mr-4 cursor-pointer">
                    <div
                      onClick={() =>
                        navigate("/GeneralBookingSelection", {
                          state: {
                            priceId:
                              customerOrdersData?.selectedPriceId
                                ? customerOrdersData?.selectedPriceId
                                : storeDefaultPrice.id,
                            BookingType: "GeneralBooking",
                            storeCustomerId: storeCustomerId,
                            bookingOrderId: bookingOrderId,
                            B2BModel: "B2BModel"
                          },
                        })
                      }
                    >
                      <img
                        src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"}
                        style={{
                          width: 25,
                          height: 25,
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <B2BGarmentInfoCard
            orderItemData={orderItemData}
            storeCustomerId={storeCustomerId}
            storeId={storeId}
            bookingOrderId={bookingOrderId}
            brandId={brandId}
            priceId={storeDefaultPrice.id}
            sendDataToOrderGarmentInfo={receiveDataFromGarmentInfoCard}
            offerDiscountByStore={offerDiscountByStore}
            offerDiscountByRider={offerDiscountByRider}
            userRole={userRole}
            offerPriceEnabled={offerPriceEnabled}
            garmentMaxProcessCount={garmentMaxProcessCount}
            garmentServiceIcons={garmentCategoryServiceIconsResData?.iconMap}
            orderEditByStore={orderEditByStore}
            enableDeleteItem={true}
            customerOrdersData={customerOrdersData}
          />

        </div>
      </div>
      <div>
        {(customerOrdersData.editBy > 0 ||
          customerOrdersData.editBy !== null) && (
            <OrderInfoEditByProfile
              setOrderInfoEditByProfileVisible={setOrderInfoEditByProfileVisible}
              orderInfoEditByProfileVisible={orderInfoEditByProfileVisible}
              editBy={customerOrdersData?.editBy}
            />
          )}
        <B2BOrderInfoEdit
          setOrderInfoEditVisible={setOrderInfoEditVisible}
          orderInfoEditVisible={orderInfoEditVisible}
          customerOrdersData={customerOrdersData}
          storeId={storeId}
          storeUserId={storeUserId}
          storeCustomerId={storeCustomerId}
          processTime={processTime}
          sendResponse={receiveResponse}
          storeCustomerData={storeCustomerData}
        />
        <OrderUnprocessedQrCode
          setOrderUnprocessedQrCode={setOrderUnprocessedQrCode}
          orderUnprocessedQrCode={orderUnprocessedQrCode}
          selectedUnprocessedQrCodeItems={selectedUnprocessedQrCodeItems}
          storeId={storeId}
          storeUserId={storeUserId}
          storeCustomerId={storeCustomerId}
          processTime={processTime}
          bookingOrderId={bookingOrderId}
          sendResponse={receiveResponse}
        />
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={modalStatusText}
          text={modalText}
        />
        <B2BOrderCancelModal
          setCancelOrderModal={setCancelOrderModal}
          cancelOrderModal={cancelOrderModal}
          sendDataToOrderInfoPage={receiveDataFromCancelModal}
          storeId={storeId}
          storeCustomerId={storeCustomerId}
          bookingOrderId={bookingOrderId}
        />
      </div>

      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default B2BOrdersGarmentInfo;